import axios from 'axios';

export var fileMixin = {
    data: () => ({
        fileUploading: false,
        fileValid: false
    }),
    watch: {
        fileUploading: function (newValue) {
            this.$emit('loading', newValue);
        }
    },
    methods: {
        postCdn: (data) => {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('file', data.data);
                axios.post('/media', formData).then((response) => {
                    if (response.data.success === false) {
                        reject(new Error('Can\'t upload the image, please refresh and retry'));
                    }
                    resolve(response.data);
                }, (err) => {
                    reject(err);
                });
            });
        },
        postFile: function (file) {
            return new Promise((resolve, reject) => {
                this.fileUploading = true;
                this.postCdn({ data: file }).then((data) => {
                    this.fileUploading = false;
                    resolve({ path: data.msg, name: file.name });
                }).catch(() => {
                    this.fileUploading = false;
                    reject(new Error('Can\'t upload file, please refresh and retry'));
                });
            });
        },
        createFile: async function (path, name, contentType) {
            let response = await fetch(path);
            let data = await response.blob();
            let metadata = {
                type: contentType
            };
            let file = new File([data], name, metadata);
            return file;
        },
        getExtension: function (value) {
            return value ? [...value.split('.')].pop() : '';
        },
        onChangeFile: function (file, fileValid) {
            return new Promise((resolve, reject) => {
                if (file && fileValid) {
                    this.postFile(file).then((data) => {
                        resolve({ shortFile: data, file: file });
                    }).catch((err) => {
                        reject(err);
                    });
                } else if (file && !this.fileValid) {
                    reject(new Error('Fichier invalide'), { path: '', name: '' });
                } else {
                    resolve({ shortFile: { path: '', name: '' }, file: [] });
                }
            });
        }
    }
};
